var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"skip-link bg-white rounded text-primary",attrs:{"href":"#main"}},[_vm._v(" "+_vm._s(_vm.$t("btn.skip-to-content"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }